import { Plus, Pencil, Trash2, X, ImagePlus, Calendar, ArrowLeft, Check } from "lucide-react";
import { useState } from "react";
const API = "";

function EditorView({ draft, setDraft, onSave, onCancel, onFiles, onRemoveImage, fileInputRef, isNew }) {
    const [dragActive, setDragActive] = useState(false);
    
    return (
        <div className="ppa-editor">
            <button onClick={onCancel} className="ppa-back-link">
                <ArrowLeft size={15} />
                К списку
            </button>

            <h1 className="ppa-title ppa-editor-title">{isNew ? "Новая страница" : "Редактирование"}</h1>

            <div className="ppa-form">
                <div className="ppa-field">
                    <label className="ppa-label">Название фотосессии</label>
                    <input
                        type="text"
                        value={draft.title}
                        onChange={(e) => setDraft((d) => ({ ...d, title: e.target.value }))}
                        placeholder="Например: Свадьба Анны и Игоря"
                        className="ppa-input"
                    />
                </div>

                <div className="ppa-field">
                    <label className="ppa-label">Дата фотосъёмки</label>
                    <input
                        type="date"
                        value={draft.shootDate}
                        onChange={(e) => setDraft((d) => ({ ...d, shootDate: e.target.value }))}
                        className="ppa-input"
                    />
                </div>

                <div className="ppa-field">
                    <label className="ppa-label">Фотографии</label>
                    <div
                        onDragOver={(e) => {
                            e.preventDefault();
                            setDragActive(true);
                        }}
                        onDragLeave={() => setDragActive(false)}
                        onDrop={(e) => {
                            e.preventDefault();
                            setDragActive(false);
                            if (e.dataTransfer.files?.length) onFiles(e.dataTransfer.files);
                        }}
                        onClick={() => fileInputRef.current?.click()}
                        className={`ppa-dropzone${dragActive ? " ppa-dropzone-active" : ""}`}
                    >
                        <ImagePlus size={22} className="ppa-dropzone-icon" />
                        <p className="ppa-dropzone-text">Перетащите файлы сюда или нажмите для выбора</p>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            multiple
                            className="ppa-hidden-input"
                            onChange={(e) => e.target.files?.length && onFiles(e.target.files)}
                        />
                    </div>

                    {draft.images.length > 0 && (
                        <div className="ppa-thumbs">
                            {draft.images.map((img) => (
                                <div key={img.id} className="ppa-thumb">
                                    <img src={img.isNew ? img.url : API + img.url} alt={img.name} className="ppa-thumb-img" />
                                    <button onClick={() => onRemoveImage(img.id)} className="ppa-thumb-remove">
                                        <X size={12} />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="ppa-actions">
                    <button onClick={onSave} disabled={!draft.title.trim()} className="ppa-btn ppa-btn-primary">
                        <Check size={16} strokeWidth={2.5} />
                        Сохранить
                    </button>
                    <button onClick={onCancel} className="ppa-btn ppa-btn-ghost">
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditorView